import React from 'react';
import './work.css';

function Aws () {
  return (
    <div className='section body-section-below-title'>
      <div className='experience-logos'>
        <a
          href='https://aws.amazon.com/'
          style={{ cursor: 'pointer' }}
          target='_blank'
          rel='noopener noreferrer'
        >
          <img
            className='experience-company-logo'
            alt='AWS Logo'
            src='/assets/aws-logo.png'
          />
        </a>
      </div>
      <div className='experience-text'>
        <div className='experience-title'>
          <div style={{ flexDirection: 'column' }}>
            <span style={{ fontSize: '22px', fontWeight: 'lighter' }}>
              Software Engineer
            </span>
            <br />
            <span style={{ fontSize: '14px', fontWeight: 'lighter' }}>
              Amazon Web Services, Seattle, USA
            </span>
          </div>
          <span style={{ fontWeight: 'lighter' }}>11/2021-present</span>
        </div>

        <div className='experience-body'>
          <ul>
            <li>
              Managing the CodeDeploy Agent release process, streamlining workflows
and reducing release time by 40%.
            </li>
            <li>
              Led development of CodeDeploy’s Multiple Target Group feature,
coordinating 3 engineers and partnering with Security, Docs, and Design
to deliver secure, scalable deployments across multiple load balancers.
            </li>
            <li>
              Drove six-month migration of the CodeDeploy console, setting technical
direction and coordinating 6 engineers and cross-functional partners to
modernize the platform and cut server-side latency by 50%.
            </li>
            <li>
              Upgraded CodeBuild to JDK 21, reducing latency by 40% and heap usage
by 66%, streamlining workflows for 15 engineers and accelerating CI/CD
cycles for hundreds of thousands of AWS customers.
            </li>
            <li>
              Drove Console and API development for the CodeBuild Mac builds feature,
expanding platform capabilities and supporting new customer workloads.
            </li>
            <li>Implemented permanent Proxy fleet for the CodeBuild NACL feature,
improving network stability and security for customer builds at scale.</li>
            <li>
              Resolved 160+ high-severity issues during CodeDeploy and CodeBuild oncall
rotations, ensuring high availability and reliability of mission-critical
services.
            </li>
            <li>Mentored and provided technical direction to an intern, resulting in
successful delivery of the CodeDeploy override alarm feature.</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Aws;
